import { render, staticRenderFns } from "./SocialMediaControl.vue?vue&type=template&id=3ea9cdb0&"
import script from "./SocialMediaControl.vue?vue&type=script&lang=js&"
export * from "./SocialMediaControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports